import React from 'react';
import { useStaticQuery } from 'gatsby';
import Icon from './icon';

var Bio = function Bio() {
  var data = useStaticQuery("139983731");
  var author = data.site.siteMetadata.author;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center"
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "mr-1 md:mr-2"
  }), /*#__PURE__*/React.createElement("p", {
    className: "self-center mx-2"
  }, "Written by ", /*#__PURE__*/React.createElement("strong", null, author)), /*#__PURE__*/React.createElement(Icon, {
    className: "ml-1 md:ml-2"
  }));
};

export default Bio;